import React from 'react';

import { Confirm } from 'components/ui/modal';
import { connect } from 'containers/store';
import { actionCreators, GettyActionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteTourRequest } from 'generated/mos/org/getty/audiomanagement'

import { pick } from 'helpers/core';
import { Status } from 'helpers/status'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';


type ConnectedProps = {
  tourDelete: GettyStore['getty']['tourDelete'];
};
type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteTourRequest' | 'gettyDeleteTourReset'> &
  Pick<SharedActionCreators, 'toastNotification'>;
type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  onCancel: () => void;
  tourRef?: DeleteTourRequest.Entity['tourRef'];
};

type Props = ConnectedProps & ActionProps & DirectProps;

const TourDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    onCancel,
    tourRef,
    tourDelete,
    toastNotification,
    gettyDeleteTourRequest,
    gettyDeleteTourReset,
  } = props

  const payload: DeleteTourRequest.Entity ={
    ...DeleteTourRequest.defaults,
    tourRef: tourRef
  }
  const onConfirmDelete = () => {
    gettyDeleteTourRequest(payload)
    historyPush(`/project/${projectId}/tours`)
  }

  if (tourDelete.status === Status.Failed) {
    toastNotification({
      type: 'error',
      text: 'Could not delete tour',
    });
    gettyDeleteTourReset();
  }

  return (
    <Confirm
      title="Delete tour?"
      onClose={onCancel}
      message={`Are you sure you want to permanently delete this tour?`}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const TourDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
    (store) => pick(store.getty, 'tourDelete'),{
      ...pick(actionCreators, 'gettyDeleteTourRequest', 'gettyDeleteTourReset'),
      ...pick(sharedActionCreators, 'toastNotification')
    }
)(TourDeleteView);
